<template>
    <div v-if="tournoi.length!=0">
        <navbar-tournoi
            :club="club"
            :tournoi="tournoi"
            :role="role"
            :joueurs="joueurs"
            display="inscription"
            @back="$emit('close')"
             @nav="setNav"
            title=" "
        />
            <div style="position: fixed;top: 60px;right: 20px;z-index: 30" >
                    <s-you-tube :id="videoId"  theme="is-info is-small" :club="club" />
                </div>
         
        <div class="inscription g_desktopOn" >

            <div class="smenu" style="height:20px;padding-top: 0px">
                <div style="text-align:center;font-size:22px;font-weight:bolder;color:black">
                    Inscription des joueurs 
                </div>    
                  
                <div style="float:right;text-align:right;margin-right: 20px;">
                    <s-button label="Démarrer" 
                        :role="role"  
                        @onclick="start()" 
                        theme="is-success" 
                        icon="play"
                        :disabled="buttonStart || forceDate==-1"
                        v-show="!tournoi.clotured"
                    />
                    <s-button label="Editer le classement" 
                        :role="role"  
                        @onclick="$emit('nav','resultatEdit')" 
                        theme="is-warning" 
                        icon="edit"
                        v-show="tournoi.clotured"
                    /><br/>
                    <div class="compteARebour" v-if="forceDate==1">
                        <div class="heuremn" >
                            <span v-if="compteAReboursDataJ!=0">{{compteAReboursDataJ}} Jr - </span>
                            <span v-if="compteAReboursDataH!=0">{{compteAReboursDataH}} H - </span>
                            <span v-if="compteAReboursDataM!=0">{{compteAReboursDataM}} mn - </span>
                            {{compteAReboursDataS}} S
                        </div> &nbsp;
                    <s-button :role="role" icon="cog" theme="is-primary is-small" @onclick="openModalConfigTournoi()" label=""/>&nbsp;
                        </div>
                        <div class="compteARebour" v-if="forceDate==0">
                        <s-l id="inscription_start"> Planifié ce jour</s-l>
                            &nbsp;<s-button icon="cog" theme="is-primary is-small" @onclick="openModalConfigTournoi()" label=""/>
                        </div>
                        <div v-if="forceDate==-1" class="compteARebour">
                            Date dépassée... 
                        </div>
                </div>
            </div>
            
         </div>  
         
            <div v-if="tournoi.options.mode=='ALEA'" class="listJoueurs">  
          
                <joueur-vue
                    :club="club"
                    :tournoi="tournoi"
                    :role="role" 
                    v-if="club.id!=''"
                    :alea="false"
                    :saison="saison"
                    :options="{inscription: true}"
                    titleMobile="Inscriptions au concours"
                    @start="start()"
                    @back="$emit('close')"
                    @editClassement="$emit('nav','resultatEdit')"
                    @addAnonymes="addJoueursInvites"
                    :hideMobile="hideMobile"
                    ref="joueurVue"
                />
               
            </div>
            <div v-if="tournoi.options.mode=='FORME'" >      
                <equipe-forme 
                    :club="club"
                    :tournoi="tournoi"
                    :role="role" 
                    v-if="club.id!=''"
                    :meneur="joueurSelectedMeneur"
                    @save="save"
                    @disabledStart="disabledStart"
                    @back="$emit('close')"
                    @start="start()"
                    ref="equipeForme"
                    @openConfig="openModalConfigTournoi()"
                    @addAnonymes="addJoueursInvites"
                   
                    />
            </div>
           
        
        <s-modal 
            title="Date expirée"
            @close="openModalStartTournoi=false"
            :open="openModalStartTournoi && forceDate==-1"
            :close="true"
        >
            <div class="notification is-danger">
                    Désolé, la date de votre tournoi est dépassée ...  <br/>
                    Vous ne pouvez plus démarrer le tournoi
            </div>
        </s-modal>
        <s-modal
            title="Concours déjà planifié"
            :open="errorDate"
            @close="errorDate=false"
            :close="true"
        >
             <div v-show="errorDate">sddsvdsf
                <s-l id="inscription_dajaPlanifie"><b> Il y a déjà un concours planifié à cette date.</b></s-l>
            </div>
        </s-modal>
        <s-confirm
            title="Confirmez vous l'inscription des préinscrits"
            :open="(openModalStartTournoi || openModalException) && isExistPresincription()"
            @no="supprimerPresincription()"
            @yes="addPresincription()"
            :close="true"
            @close="openModalStartTournoi=false;openModalException=false"
        >
         
            <div v-if="isExistPresincription()" class="msgStart">
                <s-l id="preinscrit_nonValides" :v="tournoi.preinscription.length"  >Vous avez encore %v joueurs  préinscrits où leurs inscriptions n'ont pas été validés</s-l>
                <br/><br/>
                <s-l id="preinscrit_confirm">Souhaitez-vous les inscrire ? <br/>
                   <div style="font-size:16px;text-align:center">
                   <i>(Vous pourrez valider leurs inscriptions en cours de partie via la liste des joueurs)
                   </i>
                   </div>
                </s-l>
                
            </div>
        </s-confirm>   
         <s-confirm
            title="Démarrage du concours"
            :open="openModalStartTournoi && forceDate!=-1 && !isExistPresincription()"
            @no="beforeInProgress(false)"
            @yes="beforeInProgress(true)"
            :close="true"
            @close="openModalStartTournoi=false"
        >   
            <div v-if="forceDate==1">
                <div v-show="!errorDate">
                <label class="title is-5">
                    <s-l id="inscription_alertDate" :v="formatDate(tournoi.date)">Votre concours est prévu le %v</s-l>
                    <br/>
                    <br/>
                    <s-l id="inscription_alertDate2">Souhaitez vous modifier la date de votre concours pour la forcer au {{formatDate(new Date())}} ?<br/><br/></s-l>
                </label>
                <div class="notification is-warning">
                   <s-l id="inscription_alertDate3">Attention une fois votre concours démarré, vous ne pourrez plus la modifier.</s-l>
                </div>
                </div>
               
            </div>
            
            <div v-if="forceDate==0" class="msgStart" >
                <div  >
                    <s-l id="inscription_startdetail">Vous vous apprétez à démarrer le tournoi</s-l>
                </div>
                <div v-if="tournoi.options.GG">
                    <s-l if="inscription_startdetailEplainGG">Le tirage sera effectué pour la première partie</s-l>
                </div>
                <div v-if="!tournoi.options.GG">
                    <s-l if="inscription_startdetailEplainnotGG" :v="tournoi.options.nbParties">Le tirage sera effectué pour les %v parties</s-l>

                </div>
                <div v-if="tournoi.options.mode=='ALEA'">Il y a {{tournoi.joueurs.length}} joueurs inscrits <br/></div>
                <div v-if="tournoi.options.mode=='FORME'">Il y a {{nbEquipes}} équipes inscrites <br/></div>
                <br/>
                <div >
                <s-l id="inscription_confirm">Merci de confirmer le tirage </s-l>  
                </div>
            </div>
        </s-confirm>
       <modal-start-championnat 
            :tournoi="tournoi" 
            :club="club"
            v-if="openModalCompetition"
            @close="openModalCompetition=false"
            @start="startChampionnat"
        />
       
        <s-modal
            title="Choisir les règles à appliquer"
            :open="openModalException && !isExistPresincription()"
            @close="openModalException=false"
            :close="club.id!='demo'">
            <choice-exception
                :tournoi="tournoi"
                :nbJoueurs ="nbJoueurs"
                @save="inProgress()"/>
        </s-modal>
        <s-modal
            title="Nombre de joueurs insuffisant"
            :open="errorNombre"
             :close="true"
            @close="errorNombre=false">
            <div class="notification is-danger">
                Il faut au minimum {{tournoi.options.nbJoueursParEquipe * 2}} joueurs
            </div>
        </s-modal>
        <waiting :open="modalStarting"/>
        <config-tournoi
            :tournoi="tournoi"
            :club="club"
            :open="openConfigTournoi"
            @close="closeModalConfigTournoi"
            @saved="openConfigTournoi=false"
        />
       <s-modal
            title="Pas assez de joueurs"
            :open="pasAssezJoueur"
            :close="true"
            @close="pasAssezJoueur=false">
            <s-l id="inscription_pasAssezJoueurs">Il n'y a pas assez de joueurs pour démarrer la partie</s-l>
       </s-modal>
       
       <s-modal 
            title="Choisissez votre nombre de joueurs"
            :open="openModalConfirmDemo"
            @no="openModalConfirmDemo=false"
            @yes="completerInscriptions"
            
        >
            <label class="title is-5">
                <s-l id="modeEssai">Vous êtes sur un concours en mode essai</s-l>
            </label>
            <br/>
            <label class="title is-5">
                En mode essai, c'est l'application qui inscrit pour vous les joueurs et le nombre de joueurs est limité entre 32 et 35 joueurs
            </label>
            <br/><br/>
             <label class="title is-5">
                 <s-l id="choiceNbJoueurs">Choisissez le nombre de joueurs:</s-l><br/>
                 <div class="buttonNbJoueur">
                    <div>
                        <s-button @onclick="completerInscriptions(32)" 
                           label="32 joueurs" theme="is-primary"/>
                    </div>
                    <div>
                        <s-button @onclick="completerInscriptions(33)" 
                           label="33 joueurs" theme="is-primary"/>
                    </div>
                    <div> 
                    <s-button @onclick="completerInscriptions(34)" 
                           label="34 joueurs" theme="is-primary"/>
                    </div>
                    <div>
                    <s-button @onclick="completerInscriptions(35)" 
                           label="35 joueurs" theme="is-primary"/>
                    </div>
                 </div>
             </label> 
           
       </s-modal>
    </div>
</template>
<style  scoped>
    .buttonNbJoueur {
        text-align: center;
    }
    .buttonNbJoueur div {
        display: inline-block;
        margin: 10px;
    }
    .menuFooter {
        width: 100%;
        height: 100%;
        
    }
    .menuFooter tr td {
        width: 25%;
        height: 60%;
        text-align: center;
        vertical-align: bottom;
        font-size: 14px;
        font-weight: bolder;
        margin-top: 20px;
       
    }
    .menuFooter tr td.partieFooter {
        font-size: 16px;
        height: 40%;
    }
    .sbuttonFooter {
        margin-bottom: 10px;
    }
    @media screen and (min-width: 420px) {
        .sfooter {
            display: none;
        }
        .smenu {
            
            
        }
        .listJoueurs {
            margin-top: 50px;
            
        }
    }
    @media screen and (max-width: 420px) {
        .smenu {
            display:none;
        }
         .sfooter {
             position: fixed;
             width: 100%;
             bottom: 0px;
             background-color: rgb(236, 236, 236);
             height: 100px;
             z-index: 100;
            box-shadow: 0px -3px 4px rgb(165, 165, 165);
        }
        .slideEquipe {
            padding-top: 0px;
            z-index: 500;
        }
        .listJoueurs {
            margin-bottom: 100px;
            margin-top: 60px;
           
            margin-right: 10px;
        }
    }

    .msgStart {
        color: black;
        font-size: 25px;
    }
    .inscription {
        padding-top: 20px;  
        height: 140px;  
        width: 100%; 
        position: fixed;
        z-index: 2;
        top: 40px;
         box-shadow: 0px 9px 7px -5px rgba(0,0,0,0.71);
        -webkit-box-shadow: 0px 9px 7px -5px rgba(0,0,0,0.71);
        -moz-box-shadow: 0px 9px 7px -5px rgba(0,0,0,0.71);
        background-color: var(--backgound-color);
    }
    .compteARebour {
        float: right;
        margin-right: 20px;
        margin-top: 10px;
    }
    .entete {
        width: 55px;
        display: inline-block;
        font-size: 12px;         
        text-align: center;
        border: solid white thin;    
        background-color: #008CBA;    
    }
    .heuremn {
        width: 160px;
        font-size: 12px;
        display: inline-block;
        text-align: center;
        border: solid white thin;
        font-weight: bolder;
        border: thin dashed black;
        padding-left: 2px;
        color: black;
        font-weight: bolder;
        border-radius: 10px;
    }

   
</style>
<script>
import JoueurVue from "@/views/joueurs/list.vue"
import tournoi_fct from '@/firebase/tournoi'
import credit_fct  from '@/firebase/credit'
import firebase_api from "@/firebase/firebase_api"
import joueur_fct from '@/firebase/joueur'
import ConfigTournoi from '@/views/tournoi/list/addTournoi.vue'
import navbarTournoi from "@/views/tournoi/navbar.vue"
import choiceException from "@/views/tournoi/choiceException.vue"
import navbarFooterTournoi from "@/views/tournoi/navbarfooter.vue"
import equipeForme from "@/views/tournoi/equipeForme.vue"
import modalStartChampionnat from "@/views/tournoi/championnat/modalStartChampionnat.vue"

const { v4: uuidv4 } = require('uuid');
export default {
    props:["club","tournoi", "role", "saison"],
    components: {
        JoueurVue,
        ConfigTournoi,
        navbarTournoi,
        choiceException,
        navbarFooterTournoi,
        equipeForme,
        modalStartChampionnat
    },
    data() {
        return {
            demoNbJoueurs: null,
            joueurs : [],
            errorDate: false,
            compteAReboursDataH: 0,
            compteAReboursDataM: 0,
            compteAReboursDataS: 0,
            compteAReboursDataJ: 0,
            openModalStartTournoi: false,
            openModalException: false,
            openModalCompetition: false,
            openModalConfirmDemo: false,
            saveOptions: null,
            searchJoueur: "",
            modalJoueur: false,
            nbJoueursModifier: null,
            openConfigTournoi: false,
            joueurSelectedMeneur: null,
            errorEquipe: null,
            errorNombre: false,
            dateTournoi: null,
            modalProlonger: false,
            modalStarting: false,
            buttonStart: false,
            pasAssezJoueur: false,
            optionsDate :{ 
                    weekday: 'short', 
                    year: 'numeric', 
                    month: 'short', 
                    day: 'numeric' }
           
        }
    },
    computed: {
        videoId: {
            get() {
                if (this.tournoi.options.GG) 
                    return "video_gg"
                else if (this.tournoi.options.mode == "ALEA")
                    return "video_tournante"
                else if (this.tournoi.options.competition == 3)
                    return  "video_parPoules"
                else if (this.tournoi.options.mode == "FORME")
                    return "video_formee"
            }
        },
        hideMobile: {
            get() {
                var hide = (this.openConfigTournoi || 
                    this.modalProlonger || this.modalStarting || this.openConfigTournoi || this.openModalConfirmDemo
                    || this.openModalCompetition)
              
                return hide;
            }
        },
        forceDate: {
            get() {
                var today = new Date();
                var startNumeric = this.$dateToYYYYMMDD(this.tournoi.date);
                var todayNumeric = this.$dateToYYYYMMDD(today);
                if (startNumeric == todayNumeric)
                    return 0;
                else {
                    var returnForceDate = 1;
                    if (typeof(this.tournoi.start)!="undefined")
                        if (this.tournoi.start!=null) {
                            var startNumeric = this.$dateToYYYYMMDD(this.tournoi.start);
                            if (todayNumeric > startNumeric)
                                returnForceDate = -1;
                            }
                    return returnForceDate;
                }
                    
            }
        },
        nbJoueurs: {
            get() {
                if (this.nbJoueursModifier == null)
                    return this.tournoi.joueurs.length;
                else
                    return this.nbJoueursModifier;
                
            },
            set(val) {
                this.nbJoueursModifier = parseInt(val);
            }
        },
        nbEquipes: {
            get() {
                var nbEquipes = 0;
                this.tournoi.joueurs.forEach(joueur=>{
                    if (joueur.meneur)
                        nbEquipes++;
                    })
                return nbEquipes;
            }
        }
       
    },
    methods: {
        // ***explication du workflow ***
        // le bouton démarrer appelle ma methode @start
        // on vérifie si le club est démo
        // si c'est le cas
        // on vérifie le nombre de joueur (presinscription + inscrits) est compris entre 32 et 35
        // si non alors on demande de confirmer pour completer @completerInscriptions
        // si oui alors on appelle @startAfter

        start() {
            this.startAfter();   
            /*
            var demoValid=true;
           
            if (this.club.demo) {
                var Nbjoueurs = 0;
                if (typeof(this.tournoi.preinscription)!="undefined")
                    Nbjoueurs = this.tournoi.preinscription.length;
                //Nbjoueurs += this.tournoi.joueurs.length;
                
                if (this.tournoi.options.mode=="ALEA" && (Nbjoueurs<32 || Nbjoueurs>35)) {
                    this.openModalConfirmDemo = true;
                    demoValid=false;
                }
                if (this.tournoi.options.mode=="FORME" && (this.nbEquipes<16 || this.nbEquipes>18)) {
                    this.openModalConfirmDemo = true;
                    demoValid=false;
                }
                
            }
            if (demoValid) {
                this.startAfter();          
            }
            */
        },
        // startAfter vérifie si le mode de competition est championnat
        // tournoi.options.competition à 3
        // si oui on ouvre la popup pour demander les différents mode de poule
        // si non alors on est en aléatoire ou gagnant gagnant
        // du coup on regarde si la composition est forme
        // si oui on regarde si il y a suffisement de joueurs
        
        // si ok on passe à @beforeInprogress
        startAfter() {
           
            if (this.tournoi.options.competition == 3) {
                            this.openModalCompetition = true;
            }
            else if (this.tournoi.options.mode=='FORME') {
               
                this.errorNombre = this.tournoi.joueurs.length < (this.tournoi.options.nbJoueursParEquipe * 2);
                if (!this.errorNombre) {
                    this.openModalStartTournoi = true;
                }
            }
            else
                if (this.forceDate==1)
                    this.openModalStartTournoi = true;
                else {
                    if (this.validNbJoueur())
                        this.openModalStartTournoi = true;
                    else
                        this.beforeInProgress();
                }
        },
        // on juste avant de démarrer le tournoi
        // @start et @startAfter ont été execute
        // on vérifie si le nombre de joueurs est > 3
        // si non on vérifie la date
        // si ko on demande pour forcer la date
        // on vérifie si le nombre de joueurs est ok
        beforeInProgress(yesForcage) {
            
            if (typeof(yesForcage)=="undefined")
                yesForcage = false;
            var nbJoueurs = this.tournoi.joueurs.length;
            if (typeof(this.tournoi.preinscription)!="undefined")
                nbJoueurs+=this.tournoi.preinscription.length;
            
            if (nbJoueurs>3) {
                
                if (this.forceDate==1 && yesForcage) {
                   
                    var dateSave = this.tournoi.date;
                    var today = new Date();
                    var todayTime = new Date(today.getFullYear(), today.getMonth(), today.getDate());

                    var dateTest = todayTime.getTime();
                  
                    tournoi_fct.object.verifyDate(this.club, dateTest, this.tournoi.id, bool=>{
                     
                        if (bool) {
                            this.tournoi.date = dateTest;
                        }
                        else if (!bool) {
                         
                            this.errorDate = true;
                            this.openModalStartTournoi = false;
                        }
                    });
                   
                     
                }
                else {
                    tournoi_fct.object.verifyDate(this.club, this.tournoi.date, this.tournoi.id, bool=>{
                        
                        if (bool) {
                            if (this.tournoi.options.mode == "FORME" && this.tournoi.options.GG) {
                                // dans ce cas on force 
                                //this.tournoi.options.allEquipePlay = false;
                                this.openModalStartTournoi = false;
                                this.modalStarting = false;
                                this.openModalException = true;
                                /*
                                tournoi_fct.object.set(this.club, this.tournoi,()=>{
                                     this.inProgress();
                                })
                                */
                            }
                            else if (this.validNbJoueur() && !this.tournoi.options.GG)
                                this.inProgress();
                            else {
                                this.openModalStartTournoi = false;
                                this.modalStarting = false;
                                this.openModalException = true;
                            }
                        }
                        else {
                            this.errorDate = true;
                            this.openModalStartTournoi = false;
                        }
                    });
                    
                }
              
            }
            else {
                this.pasAssezJoueur = true;
            }
                
        },
        // on démarre le tournoi
        inProgress() {
            // bon bah là c'est parti pour le tirage
            // on change l'état du tournoi
            // on créer une collection tournoi
            // on fait le tirage
            
           this.modalStarting = true;
            setTimeout(
                ()=>{
                   
                    tournoi_fct.object.setState(this.club, this.tournoi, "INPROGRESS", (tournois)=>{
                       
                        this.$emit("inprogress");
                        setTimeout(()=>{
                                this.modalStarting = false;
                        }, 1000);
                        
                    })
                },
                400
            )
        },
         addJoueursInvites(nbJoueursAnonymes) {
         
            
            for (var i=0;i<nbJoueursAnonymes;i++) {
                var joueurTempo = JSON.parse(JSON.stringify(joueur_fct.object.tournoi));
                joueurTempo.id = uuidv4();
                joueurTempo.invite = true;
             //   this.joueurs.push(joueurTempo);
                if (typeof(this.tournoi.preinscription)=="undefined") {
                    this.tournoi.preinscription = [];
                }
                this.tournoi.preinscription.push(joueurTempo.id);
                if (typeof(this.tournoi.invites)=="undefined") {
                    this.tournoi.invites = {};
                }
                this.tournoi.invites[joueurTempo.id] = joueurTempo;
            }
            
            tournoi_fct.object.set(this.club, this.tournoi ,()=>{
              
                if (typeof(this.$refs.joueurVue)!="undefined")
                    this.$refs.joueurVue.refresh();
                if (typeof(this.$refs.equipeForme)!="undefined") {
                    this.addPresincription(false);
                    this.$refs.equipeForme.refresh();
                }
            });
         
        },
        async addInvit() {
            var joueur = JSON.parse(JSON.stringify(joueur_fct.object.tournoi));
            joueur.pseudo = '';
            joueur.pseudoMaj = '';
            joueur.id = uuidv4();
            joueur.invite = true;
            
        //    this.joueurs.push(joueur);
            if (this.tournoi.mode == 'ALEA')
                this.tournoi.preinscription.push(joueur.id);
            else
                this.tournoi.joueurs.push(joueur);
            if (typeof(this.tournoi.invites)=="undefined") {
                this.tournoi.invites = {};
            }
            this.tournoi.invites[joueur.id] = JSON.parse(JSON.stringify(joueur));
           
        },
        async completerInscriptions(nbreJoueurs) {
            
             // on complète le nombre de joueurs 
             // à ce stade tout est dans this.tournoi.preinscription
             // il suffit dont de parcourir les joueurs pour en ajouter ou en supprimer
             this.tournoi.preinscription = [];
             this.tournoi.joueurs = [];
              if (typeof(this.tournoi.preinscription)=="undefined") {
                  this.tournoi.preinscription = [];
              }
            if (this.joueurs.length == 0)
                await this.$bind("joueurs", firebase_api.api.getDb().collection("club").doc(this.club.id)
                    .collection("joueurs"));
                var addJoueur = nbreJoueurs;
                var compteurJoueur = 0;
                this.joueurs.forEach(joueur=>{
                        if (compteurJoueur<nbreJoueurs) {
                            var indexPreinscrit = this.tournoi.preinscription.indexOf(joueur.id);
                            if (indexPreinscrit==-1 && addJoueur > 0) {
                                compteurJoueur++;
                                this.tournoi.preinscription.push(joueur.id);
                            }
                        }
                })
              
            
              
             this.openModalConfirmDemo = false;
             this.addPresincription(true);
             if (this.tournoi.options.mode=="FORME")
                this.$refs.equipeForme.generateTeamsAlea();
             //this.start();
         },
         validNbJoueur() {
           
            if (this.tournoi) {
                if (this.nbJoueurs == 0)
                    return false;
                else {
                    var reste ;
                   
                    if (this.tournoi.options.mode == 'ALEA') {
                        if (this.tournoi.options.nbJoueursParEquipe==-1) {
                            return true;
                        }
                        else
                        if (this.tournoi.options.nbJoueursParEquipe==1) {
                            
                                reste = this.nbJoueurs % 2;
                                if (reste == 0)
                                    return true;
                                else    
                                    return false;
                        }
                        else {
                            
                            reste = this.nbJoueurs % (this.tournoi.options.nbJoueursParEquipe * 2);
                          
                            if (reste == 0) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                    }
                    else {
                        var nbEquipes = 0;
                        this.tournoi.joueurs.forEach(joueur=>{
                            if (joueur.meneur)
                                nbEquipes++;
                        })
                        
                        return (nbEquipes % 2) == 0;

                    }
                }
            }
            else
                return false;
        
        },
         setNav(nav) {
            this.$emit("nav",nav)
          },
        isExistPresincription() {
            if (typeof(this.tournoi.preinscription)=="undefined")
                return false;
            else {
                var bool = false;
                
                for (var indexPreinscription in this.tournoi.preinscription) {
                    var joueurId = this.tournoi.preinscription[indexPreinscription];
                    var index  = this.tournoi.joueurs.findIndex(joueur=>joueur.id === joueurId);
                    if (index==-1) {
                        bool = true;
                        return true;
                        break;
                    }
                }
                return bool;
            }
        },
        supprimerPresincription() {
            //this.tournoi.preinscription=[];
            this.openModalStartTournoi = false;
            this.openModalException = false;
            //this.start();
        },
        aleatoireInscription() {
            var listJoueurs=[];
            var listJoueursSup=[];
            
            listJoueursSup = JSON.parse(JSON.stringify(this.tournoi.joueurs.slice()));
            for (var index=0;index<this.tournoi.joueurs.length;index++) {
                listJoueursSup[index] = index;
            }
           
            this.tournoi.joueurs.forEach((joueur, index)=>{
                var indexFind  = this.random(0, listJoueursSup.length);
                var numero = listJoueursSup[indexFind];
                
                listJoueurs[index] = JSON.parse(JSON.stringify(this.tournoi.joueurs[numero]));
                listJoueursSup.splice(indexFind,1);
            })
            this.tournoi.joueurs = JSON.parse(JSON.stringify(listJoueurs));
           
        },
        async addPresincription(notStart) {
           
            if (this.joueurs.length == 0)
                    await this.$bind("joueurs", firebase_api.api.getDb().collection("club").doc(this.club.id)
                        .collection("joueurs"));
            
           
            this.tournoi.preinscription.forEach(idJoueurPreinscrit=>{
                   
                    var index = this.tournoi.joueurs.findIndex(joueur=>joueur.id === idJoueurPreinscrit);
                    if (index==-1) {
                        var indexJoueur = this.joueurs.findIndex(joueur=>joueur.id === idJoueurPreinscrit);
                        if (indexJoueur!=-1) {
                            var joueurItem = this.joueurs[indexJoueur];
                            joueurItem.invite = false;
                        }
                        else {
                           
                            var joueurItem = this.tournoi.invites[idJoueurPreinscrit];
                            joueurItem.invite = true;
                        }
                        var joueurTournoi = JSON.parse(JSON.stringify(joueur_fct.object.tournoi));
                        joueurTournoi.id = joueurItem.id;
                        joueurTournoi.pseudo = joueurItem.pseudo;
                        joueurTournoi.nom = joueurItem.nom;
                        joueurTournoi.prenom = joueurItem.prenom;
                        joueurTournoi.inscriptionValide = false;
                        joueurTournoi.invite = joueurItem.invite;
                        this.tournoi.joueurs.push(joueurTournoi);
                    }
                    else
                         this.tournoi.joueurs[index].inscriptionValide = true;
               })
            this.openModalStartTournoi = false;
            this.openModalException = false;
            this.aleatoireInscription();
            this.save(this.tournoi);
            
            
            if (typeof(notStart)=="undefined")
                this.startAfter();          
            else if (notStart)
                this.startAfter();          
            
        },
        disabledStart(buttonStart) {
            this.buttonStart = buttonStart;
        },
        handleJoueurs() {
            if (this.nbJoueursModifier < this.tournoi.joueurs.length) {
                this.nbJoueursModifier = this.tournoi.joueurs.length
            }
        },
        openModalJoueurWidthMeneur(joueurMeneur) {
            this.joueurSelectedMeneur = joueurMeneur;
            this.modalJoueur = true;
        },
        getJoueurById(idJoueur) {
            var indexJoueur = this.tournoi.joueurs.findIndex(joueur=>joueur.id===idJoueur);
            if (indexJoueur!=-1) {
                return this.tournoi.joueurs[indexJoueur].pseudo;
            }
        },
        
        closeModalJoueur() {
            this.modalJoueur = false;
            this.joueurSelectedMeneur = null;
        },
        setMeneur(joueurMeneur) {
            this.joueurSelectedMeneur = joueurMeneur
        },
        openModalConfigTournoi () {
            this.saveOptions = JSON.parse(JSON.stringify(this.tournoi.options));
            this.openConfigTournoi = true;
        },
        closeModalConfigTournoi() {
            this.tournoi.options = JSON.parse(JSON.stringify(this.saveOptions));
            this.openConfigTournoi=false
            
        },
        
        search(joueurItem) {
            if (this.searchJoueur=="")
                return true;
            else {
                if (joueurItem.pseudo.toUpperCase().indexOf(this.searchJoueur.toUpperCase()) == 0)
                    return true;
                else    
                    return false;
            }
        },
        
        startChampionnat() {
            this.$emit("inprogress");
        },
        
        openParties() {
             this.$emit("inprogress");
        },
        random(min, max) {
            return Math.floor(min + Math.random() * (max - min));
        },
        
        addJoueur() {
            this.modalJoueur = true;
            //this.$emit("addJoueur");
        },
        save(tournoi) {
            
             if (typeof(tournoi) == "undefined") {
                 tournoi_fct.object.set(this.club, this.tournoi,()=>{

                })
             }
             else
             {
                 tournoi_fct.object.set(this.club, tournoi,()=>{
                     this.$emit("refresh", tournoi)
                })
             }
        },
        
        formatDate(date) {
             var options = { year: "numeric", month: "2-digit", day: "2-digit"};
            return (new Date(date)).toLocaleString("fr-Fr",options);
        },
        dateDiff(date1,date2) {
             var diff = {}                           // Initialisation du retour
                var tmp = date2 - date1;
            
                tmp = Math.floor(tmp/1000);             // Nombre de secondes entre les 2 dates
                diff.sec = tmp % 60;                    // Extraction du nombre de secondes
            
                tmp = Math.floor((tmp-diff.sec)/60);    // Nombre de minutes (partie entière)
                diff.min = tmp % 60;                    // Extraction du nombre de minutes
            
                tmp = Math.floor((tmp-diff.min)/60);    // Nombre d'heures (entières)
                diff.hour = tmp % 24;                   // Extraction du nombre d'heures
                
                tmp = Math.floor((tmp-diff.hour)/24);   // Nombre de jours restants
                diff.day = tmp;
                
                return diff;
        },
        getMinutes(date) {
            var minutes = date.getMinutes();
            if (minutes < 10)
                return "0" + minutes;
            else 
                return minutes;
        },
        compteARebours() {
            if (this.tournoi.length!=0) {
            var dateCourante = new Date();
            var options = { year: "2-digit", month: "2-digit", day: "2-digit"};
          
            var datePlanifie = new Date(this.tournoi.date);
            var dateConstruct = new Date (
                    datePlanifie.getFullYear(),
                    datePlanifie.getMonth(),
                    datePlanifie.getDate(),
                    this.tournoi.heure.split(":")[0],
                    this.tournoi.heure.split(":")[1],
                    0)
           
            var compare = dateCourante.getTime() - dateConstruct.getTime();
          
            if (compare < 0) {
                this.dateTournoi = this.formatDate(this.tournoi.date) + " à " + this.tournoi.heure;
                var diff = this.dateDiff(dateCourante, dateConstruct );
                this.compteAReboursDataJ = diff.day;
                this.compteAReboursDataH = diff.hour; 
                this.compteAReboursDataM = diff.min;
                this.compteAReboursDataS = diff.sec;
            }
            else {
                this.dateTournoi = this.formatDate(dateCourante) + " à " + dateCourante.getHours() + ":" + this.getMinutes(dateCourante);
                this.compteAReboursDataH = 0;
                this.compteAReboursDataM = 0;
                this.compteAReboursDataS = 0;
                this.compteAReboursDataJ = 0;
            }
            
            setTimeout(
                ()=>{
                    this.compteARebours()
                },
                1000
            )
        }
        }
    },
    mounted() {
        if (this.club.id=="demo") {
            this.openModalConfirmDemo = true;
        }
        this.compteARebours();
         this.$bind("joueurs", firebase_api.api.getDb().collection("club").doc(this.club.id)
                        .collection("joueurs"));
    }
}
</script>